import * as t from "io-ts";
const uuidFormat = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export const uuidT = t.refinement(t.string, (s) => uuidFormat.test(s), "Uuid");
//# sourceMappingURL=uuid.js.map